module.exports = __webpack_public_path__ + "img/HQ-OA-360V03NU-T.46184c1a.jpg";